<template>
  <!-- START Login Right Container-->
  <div class="login-container bg-white">
    <div class="p-l-50 m-l-20 p-r-50 m-r-20 p-t-50 m-t-30 sm-p-l-15 sm-p-r-15 sm-p-t-40">
      <img src="~assets/img/logo-sofradom.png" alt="logo" data-src="~assets/img/logo-sofradom.png" data-src-retina="~assets/img/logo-sofradom.png" width="180">
      <p class="p-t-35" v-if="tokenIsInvalid">
        Reconnectez vous à votre compte
      </p>
      <p class="p-t-35" v-else>
        Connectez vous à votre compte
      </p>
      <!-- START Login Form -->
      <form id="form-login" class="p-t-15" role="form" @submit.prevent="authenticate({email, password, rememberEmail})">
        <!-- START Form Control-->
        <div class="form-group form-group-default">
          <label>E-Mail</label>
          <div class="controls">
            <input type="text" name="e-mail" :disabled="reconnecting" placeholder="Adresse e-mail" class="form-control" v-model="email" required>
          </div>
        </div>
        <!-- END Form Control-->
        <!-- START Form Control-->
        <div class="form-group form-group-default">
          <label>Mot de passe</label>
          <div class="controls">
            <input type="password" class="form-control" name="password" placeholder="Mot de passe" v-model="password" required>
          </div>
        </div>
        <!-- START Form Control-->
        <div class="row">
          <div class="col-md-6 no-padding">
            <div class="checkbox ">
              <!-- <input type="checkbox" value="1" id="checkbox1"> -->
              <input type="checkbox" v-model="rememberEmail" id="checkbox1">
              <label for="checkbox1">Enregistrer mon adresse email</label>
            </div>
          </div>
          <div class="col-md-6 text-right">
            <a href="#" class="text-info small" @click.prevent="reconnecting = false">Changer adresse email</a> <br>
            <a :href="passwordResetLink" target="_blank" class="text-info small">Mot de passe oublié ?</a>
          </div>
        </div>
        <!-- END Form Control-->
        <button class="btn btn-primary btn-cons m-t-10" type="submit">Se connecter</button>
      </form>
      <!--END Login Form-->
      <!-- <div class="pull-bottom sm-pull-bottom">
        <div class="m-b-30 p-r-80 sm-m-t-20 sm-p-r-15 sm-p-b-20 clearfix">
          <div class="col-sm-3 col-md-2 no-padding">
            <img alt="" class="m-t-5" data-src="~assets/img/demo/pages_icon.png" data-src-retina="~assets/img/demo/pages_icon_2x.png" height="60" src="~assets/img/demo/pages_icon.png" width="60">
          </div>
          <div class="col-sm-9 no-padding m-t-10">
            <p>
              <small>
              Create a pages account. If you have a facebook account, log into it for this
              process. Sign in with <a href="#" class="text-info">Facebook</a> or <a href="#"
                                                                                     class="text-info">Google</a>
            </small>
            </p>
          </div>
        </div>
      </div> -->
    </div>
  </div>
  <!-- END Login Right Container-->
</template>

<script>
  import { mapActions, mapState } from 'vuex'
  import { DEFAULT_EMAIL } from '../../store/mutation-types'

  export default {
    props: ['tokenIsInvalid'],

    data () {
      return {
        password: "",
        rememberEmail: false,
        reconnecting: false
      }
    },

    created () {
      this.reconnecting = this.tokenIsInvalid && !_.isNil(this.email)
    },

    // TODO: handle mutation arguments
    // vuexComputed: {
    //   email: {
    //     mutationType: DEFAULT_EMAIL,
    //     statePropName: 'userEmail',
    //     debounce: 300
    //   }
    // },

    computed: {
      email: {
        get () {
          return this.$store.state.userEmail
        },
        set: _.debounce(function (email) {
          this.$store.commit(DEFAULT_EMAIL, email)
        }, 300)
      },
      passwordResetLink() {
        return __CLIENT_URL__ + '/password/reset'
      },
      ...mapState(['isLoggedIn'])
    },

    methods: {
      ...mapActions( { authenticate: 'loginUser' } )
    }
  }
</script>



// WEBPACK FOOTER //
// client/components/Login/FormContainer.vue